export const isLiveDate = (startDate, endDate) => {
  if (!startDate || !endDate) {
    return false;
  }
  const now = Date.now();
  const start = new Date(startDate).getTime();
  const end = new Date(endDate).getTime();
  return now >= start && now <= end;
};

export const getEventStartAndEndDate = (event) => {
  if (!event) return { startDate: null, endDate: null };
  const { startDate, endDate } = event;

  return {
    startDate,
    endDate,
  };
};

export const getLiveEvent = (events) =>
  events.find((event) => isLiveDate(event?.startDate, event?.endDate)) ?? null;
